module.exports = __webpack_public_path__ + "img/404.fa7716ce.png";